<script setup lang="ts">
import WDefaultHeader from './WDefaultHeader.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { ObjectAliases } from '@/entities/Object'
import { useObjectTree } from '@/entities/ObjectsTree'
import WCabinetHeader from './WCabinetHeader.vue'
import WGroupHeader from './WGroupHeader.vue'
import './assets/style.scss'
import WInventoryHeader from '@/widgets/ObjectHeader/ui/WInventoryHeader.vue'

const route = useRoute()
const tree = useObjectTree()

const header = computed(() => {
  const type = route.params.type as ObjectAliases

  switch (type) {
    case ObjectAliases.CABINETS:
      return WCabinetHeader
    case ObjectAliases.GROUPS:
      return WGroupHeader
    case ObjectAliases.INVENTORY:
      return WInventoryHeader
    default:
      return WDefaultHeader
  }
})

/**
 * Обрабатываем событие успешной загрузки объекта
 * @param data
 */
const loadData = (data: any) => {
  if (data) {
    tree.pathObject = data.parents.map((item: any) => item.id)
  }
}
</script>

<template>
  <component :is="header" @loadData="loadData" />
</template>
